<template>
  <AssetSelectionList
    ref="list"
    disabled
    :module-name="$constants.ASSET_HARDWARE"
    :fetch-fn="fetchAssetFn"
    searchable
    :show-no-data="false"
    :has-actions="false"
  >
    <template v-slot:search-selector><span /></template>
  </AssetSelectionList>
</template>

<script>
import AssetSelectionList from '@components/item-selection-list/asset-list'
import { searchAssetInstallationApi } from '@modules/asset/asset-api'
export default {
  name: 'InstallationTab',
  components: { AssetSelectionList },
  props: {
    resourceId: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    fetchAssetFn(_, criterias, limit, offset) {
      return searchAssetInstallationApi(
        this.resourceId,
        criterias,
        limit,
        offset
      )
    },
  },
}
</script>
